import { useEffect } from "react";
import { startLenisRaf } from "@/lib/lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const stop = startLenisRaf();
    return () => stop();
  }, []);

  return (
    <div className="App bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
